import { Component, inject, ViewContainerRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TransportJobReportStoreService } from './transport-job-report-store.service';
import { ProductService } from '../../shared';
import { ProductCategoryService } from '../../shared/services/product-category.service';
import { ReportService } from '../shared/services/report.service';
import { ControlsDialogComponent } from './controls-dialog/controls-dialog.component';
import { TransportJobTableComponent } from './transport-jobs-table/transport-job-table.component';
import { map } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { UserIdToNamePipe } from '../../shared/pipes/user-id-to-name.pipe';
import { MomentModule } from 'ngx-moment';
import { ConfigService } from 'src/app/shared/services/config.service';
@Component({
  selector: 'app-transport-job-report',
  templateUrl: './transport-job-report.component.html',
  providers: [
    TransportJobReportStoreService,
    ProductService,
    ProductCategoryService,
    ReportService
  ],
  standalone: true,
  imports: [
    TransportJobTableComponent,
    AsyncPipe,
    UserIdToNamePipe,
    MomentModule
  ]
})
export class TransportJobReportComponent {
  store = inject(TransportJobReportStoreService);
  filters$ = this.store.filters$;

  from$ = this.filters$.pipe(map((filters) => filters.from));
  to$ = this.filters$.pipe(map((filters) => filters.to));
  assignedTo$ = this.filters$.pipe(map((filters) => filters.assignedTo));
  reportGenerated$ = this.store.reportGenerated$;
  dialog = inject(MatDialog);
  vcr = inject(ViewContainerRef);
  dateFormat = ConfigService.dates.shortDateTimeFormat;
  constructor() {}

  openControlsDialog() {
    this.dialog.open(ControlsDialogComponent, {
      viewContainerRef: this.vcr
    });
  }
}
